module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "h2"
    }
  }, [_vm._v("List of Maps")])]), _c('a', {
    attrs: {
      "id": "h2"
    }
  }, [_c('p', {
    staticClass: "common"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/common.jpg"
    }
  })])]), _c('p', {
    staticClass: "list"
  }, [_c('a', {
    attrs: {
      "id": "h2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/10_chapter011#map1"
    }
  }, [_vm._v("1. Plan of the battles of Tel-el-Kebir and Kassassin, 1882. (From Sir Evelyn Wood, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("British Battles on Land and Sea")]), _vm._v(", London: Cassell & Co., 1915)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter021#map2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Plan of the battle of Khambula, 1879. (From Sir Evelyn Wood, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("British Battles on Land and Sea")]), _vm._v(", London: Cassell & Co., 1915)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter031#map3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Plan of the battle of Colenso, 1899. (From W Baring Pemberton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Battles of the Boer War")]), _vm._v(", London: Batsford, 1964)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter041#map4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Plan of the battle of Majuba, 27 February 1881.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter042#map5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Plan of the battles of Laing’s Nek, Schuinshootge and Majuba, 1881.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/34_chapter051#map6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Plan of the Isandlwana campaign, 1879. (With permission of the University of KwaZulu-Natal Press)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/37_chapter061#map7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Map to illustrate General Gordon’s Journals. (From A Egmont Hake, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Journals of Major-General C G Gordon CB, at Khartoum")]), _vm._v(", London: Kegan Paul, Trench, 1885)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/39_chapter063#map8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Khartoum and environs.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/42_chapter071#map9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Plan of the north-west frontier and Afghanistan. (From G Forrest, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Life of Lord Roberts, KG, VC")]), _vm._v(", London: Cassell & Co., 1914)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/44_chapter073#map10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Plan of the battle of Paardeberg, 1900. (From David James, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lord Roberts")]), _vm._v(", London: Hollis & Carter, 1954)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/46_chapter075#map11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Plan of the north-west frontier of India. (From David James, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lord Roberts")]), _vm._v(", London: Hollis & Carter, 1954)")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/49_chapter081#map12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The South African War, 1899–1902.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/50_chapter082#map13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. The battle of Omdurman, phase one, 2 September 1898.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/51_chapter083#map14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. The battle of Omdurman, phase two, 2 September 1898.")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    attrs: {
      "href": "#/53_chapter085#map15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The battle of Omdurman, phase three, 2 September 1898.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6614732d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_maps.vue
// module id = 69
// module chunks = 0